import { render, staticRenderFns } from "./AccountManagementCreditsForm.vue?vue&type=template&id=4c35568c&"
import script from "./AccountManagementCreditsForm.vue?vue&type=script&lang=ts&"
export * from "./AccountManagementCreditsForm.vue?vue&type=script&lang=ts&"
import style0 from "./AccountManagementCreditsForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports